import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import ContactList from "./components/ContactList";
import AddContactForm from "./components/AddContactForm";
import DocumentCreation from "./components/DocumentCreation";
import HomePage from "./components/HomePage";

export default function ContactManager() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // Load API URL from environment variables
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  // console.log("API Base URL:", API_BASE_URL);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token && token !== "null" && token !== "undefined") {
      fetchContacts();
    }
  }, [token]);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/contacts/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContacts(response.data);
    } catch (err) {
      console.error("Error fetching contacts:", err);
      if (err.response?.status === 401) {
        alert("Session expired. Please log in again.");
      }
    }
    setLoading(false);
  };

  const deleteContact = async (contactId) => {
    try {
      await axios.delete(`${API_BASE_URL}/contacts/${contactId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContacts(contacts.filter((contact) => contact.id !== contactId));
    } catch (error) {
      alert("Failed to delete contact.");
    }
  };

  const updateContact = async (contactId, updatedData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/contacts/${contactId}`, updatedData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContacts(contacts.map((contact) =>
        contact.id === contactId ? { ...contact, ...response.data } : contact
      ));
    } catch (error) {
      alert("Failed to update contact.");
    }
  };

  const logout = () => {
    setToken("");
    localStorage.removeItem("token");
  };

  return (
    <Router>
      <div className="container mt-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", paddingBottom: "60px" }}>
        <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm mb-4">
          <div className="container-fluid">
            <span className="navbar-brand display-4 fw-bold">CRM Advocaten</span>
            <div>
              <Link className="btn btn-outline-primary mx-2" to="/">Home</Link>
              {token && <Link className="btn btn-outline-secondary mx-2" to="/contacts">Contacten Beheren</Link>}
              {token && <Link className="btn btn-outline-secondary mx-2" to="/documents">Document Aanmaken</Link>}
              {token && <button className="btn btn-danger" onClick={logout}>Logout</button>}
            </div>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<HomePage setToken={setToken} token={token} />} />
          <Route path="/contacts" element={token ? <>
            <AddContactForm fetchContacts={fetchContacts} token={token} API_BASE_URL={API_BASE_URL} />
            {loading ? (
              <div className="text-center my-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <ContactList contacts={contacts} deleteContact={deleteContact} updateContact={updateContact} />
            )}
          </> : <Navigate to="/" />} />
          <Route path="/documents" element={token ? <DocumentCreation /> : <Navigate to="/" />} />
        </Routes>
        <footer className="text-center mt-4 p-3" style={{ position: "absolute", bottom: "0", width: "100%", backgroundColor: "#343a40", color: "white" }}>
          <img src="/logo.png" alt="CRM Advocaten Logo" style={{ height: "40px", marginBottom: "5px" }} />
          <p>© 2024 CRM Advocaten. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}
